export class WorkOrderProposalActionConstants {
    static readonly GENERATE_RFP = 'generateRFP';
    static readonly ACCEPT = 'acceptProposal';
    static readonly EDIT = 'editProposal';
    static readonly REMOVE = 'removeProposal';
}
